import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { SupportEditPage } from './pages/SupportEditPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/support`,
        element: <Outlet />,
        children: [{ index: true, element: <SupportEditPage /> }],
    },
];

export default routes;
